import '@chewy/kib-label-styles/dist/kib-label.css';
import { KibIcon, KibAiSparklesIcon } from '@chewy/kib-icons-react';
import '@chewy/kib-patterns/dist/styles/kib-icon.css';
import styles from './AiBadge.module.scss';

export interface AiBadgeProps {
  subject?: string;
  placeholderSuffix?: string;
}


export default function AiBadge({ subject = 'Cai', placeholderSuffix}: AiBadgeProps) {
  return (
    <span className={styles.aiBadge} aria-hidden="true">
      <KibIcon className={styles.icon} aria-hidden>
        <KibAiSparklesIcon />
      </KibIcon>

      <span className={styles.text}>{`${subject}${placeholderSuffix ? ` (${placeholderSuffix})` : ''}`}</span>
    </span>
  );
}
